import React from 'react';
import { formatTime } from '../../utils/formatTime';

const card = { background: 'var(--glass)', borderRadius: 10, padding: 16, border: '1px solid var(--glass-border)' };
const label = { fontSize: 12, color: 'var(--text-3)', marginBottom: 4 };
const value = { fontSize: 24, fontFamily: 'var(--mono)', color: 'var(--text-1)' };
const sub = { fontSize: 12, color: 'var(--text-3)', marginTop: 4 };

export default function DeviceMetricsPanel({ device }) {
  if (!device) return null;

  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 16 }}>
      <div style={card}>
        <div style={label}>Uptime</div>
        <div className="mono" style={value}>
          {device.last_polled_at ? 'Online' : 'N/A'}
        </div>
        <div style={sub}>
          Last poll: {device.last_polled_at ? formatTime(device.last_polled_at) : 'Never'}
        </div>
      </div>
      <div style={card}>
        <div style={label}>Firmware</div>
        <div className="mono" style={value}>
          {device.firmware_version || '-'}
        </div>
        <div style={sub}>
          {device.vendor} {device.model}
        </div>
      </div>
      <div style={card}>
        <div style={label}>Open Incidents</div>
        <div className="mono" style={{ ...value, color: device.incident_count > 0 ? 'var(--danger)' : 'var(--success)' }}>
          {device.incident_count || 0}
        </div>
        <div style={sub}>Active incidents</div>
      </div>
      <div style={card}>
        <div style={label}>CVEs</div>
        <div className="mono" style={{ ...value, color: device.cve_count > 0 ? 'var(--warning)' : 'var(--success)' }}>
          {device.cve_count || 0}
        </div>
        <div style={sub}>Open vulnerabilities</div>
      </div>
    </div>
  );
}
